import React from 'react';
import {Image} from "../../../../core/components/image/image";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {CompetitorPlayersStatsModuleShots} from "./competitor-players-stats-module.shots";
import {ShotMapSvgField} from "../../../../core/components/shot-map/svg-field/shot-map.svg-field";
import {GAME_SHOT_CHARTS} from "../../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";
import {observer} from "mobx-react";

export const CompetitorPlayersStatsModuleShotChart = observer(({controller, width, height}) => {
  if (!width || !height) {
    return null;
  }

  const {state} = controller;
  const {sportTypeId, courtType, sportContext, selectedPlayer, isShallowShotMap} = state;
  const {selectedShot, hasShotChart} = selectedPlayer;
  const {shouldRenderAnimation} = sportContext;

  const imageProps = {
    className: classNames(styles.court_img),
    src: new courtType(width, height, sportTypeId, isShallowShotMap),
  }

  const shotsProps = {
    controller,
    selectedPlayer,
    width,
    height
  }

  const svgCourtProps = {
    controller,
    width,
    ratio: GAME_SHOT_CHARTS.COURT_RATIO_FOOTBALL,
    shouldRenderAnimation,
    shotSideOffset: GAME_SHOT_CHARTS.SHOTS_OFFSET.side,
    shotLineOffset: GAME_SHOT_CHARTS.SHOTS_OFFSET.line,
    selectedShot
  }

  const courtProps = {
    className: classNames(styles.court),
    style: {height}
  }

  return (
    hasShotChart ? <div  className={classNames(styles.court_container)}>
      <div {...courtProps}>
        <Image {...imageProps}/>
        <CompetitorPlayersStatsModuleShots {...shotsProps}/>
        <ShotMapSvgField {...svgCourtProps}/>
      </div>
    </div> : null
  )
})
